function isThunk(fn) {
    return (typeof fn === "function" &&
        typeof fn.run === "function" &&
        typeof fn.name === "string" &&
        typeof fn.key === "string" &&
        typeof fn.toString === "function");
}
export function matcher(pattern) {
    if (pattern === "*") {
        return (input) => !!input;
    }
    if (typeof pattern === "string") {
        return (input) => pattern === input.type;
    }
    if (Array.isArray(pattern)) {
        return (input) => pattern.some((p) => matcher(p)(input));
    }
    // detects thunk action creators
    if (isThunk(pattern)) {
        return (input) => pattern.toString() === input.type;
    }
    if (typeof pattern === "function") {
        return (input) => pattern(input);
    }
    throw new Error("invalid pattern");
}
